import template from './monthSelector.html';
import controller from './monthSelector.controller';
import './monthSelector.scss';

let monthSelectorComponent = {
  restrict: 'E',
  bindings: {
    onChange: '&'
  },
  template,
  controller
};

export default monthSelectorComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendarMobile/monthSelector/monthSelector.component.js